import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { noUserEmailMsg, cantResetPassTitle, userEmailNotConfirmedMsg, generalErrMsg, badEmailFormat } from "../../global/popupMessages";
import userService from "../../Services/userService";
import bquickLogo from "../../assets/images/bquick-logo.png";

export default class ForgetPassword extends Component {
  state = {
    email: ""
  };

  render() {
    return (
      <div className="">
        <div className="row">
          <div className="col-sm-12 center mt-50">
            <Link to="/login">
              <img width="150" src={bquickLogo} />
            </Link>
          </div>
          <div className="col-lg-3"></div>
          <div className="col-sm-12 col-lg-6">
            <Card>
              <CardContent className="login-card">
                <h4>
                  <b>לא זוכר את הסיסמה?</b>
                </h4>
                <div className="mb-10">
                  אל חשש! איפוס סיסמה הוא פשוט מאוד.
                  <br />
                  כל שעליך לעשות הוא להזין לשדה הבא את האימייל שלך
                </div>
                <div className="mb-20 mt-20 padding20">
                  <TextField required id="email" onChange={this.handleChange} label="מה המייל שלך?" type="email" />
                </div>
                <div className="mb-20">
                  <Button color="primary" variant="contained" onClick={this.handleSubmit}>
                    לחץ לאיפוס
                  </Button>
                </div>
                <span className="d-block text-14">
                  זוכר את הסיסמה שלך? לחץ לכניסה
                  <Link to="/"> כאן </Link>
                </span>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.state.email) {
      Swal.fire("", "יש להכניס אימייל", "warning");
      return;
    }
    userService.resetUserPass(this.state.email).then((res) => {
      if (res["err"]) {
        Swal.fire("", generalErrMsg, "warning");
      } else if (res["validationErr"]) {
        Swal.fire("", badEmailFormat, "warning");
      } else if (!res["isUserFound"]) {
        Swal.fire(cantResetPassTitle, noUserEmailMsg, "warning");
      } else if (!res["isUserConfirmed"]) {
        Swal.fire(cantResetPassTitle, userEmailNotConfirmedMsg, "warning");
      } else if (res["success"]) {
        this.props.history.push("/message/reset-pass-msg");
      }
    });
  };
}
